const l = {
  name: "FolderFill",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 3C2.34315 3 1 4.34315 1 6V18C1 19.6569 2.34315 21 4 21H20C21.6569 21 23 19.6569 23 18V9C23 7.34315 21.6569 6 20 6H14.4142L12.2929 3.87868C11.7303 3.31607 10.9672 3 10.1716 3H4Z" fill="currentColor"/>
</svg>
  `
};
export {
  l as FolderFill
};
